export const CAR_PRIZE_JAN_26_URL = '/blog/2025/12/18/win-a-car-terms-conditions';
